import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import FooterCorp from "../modulos/footerCorp";
import CadetesParaFranco from "../GuardiaPrevencion/CadetesParaFranco";
import axios from "axios";
import CadetesBuscador from "../NCadetes/CadetesBuscador";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import Swal from "sweetalert2";
import CadetesBuscadorPresente from "../NCadetes/CadetesBuscadorPresentes";
import socket from "../tools/socke";
import MuestraSecciones from "../GuardiaPrevencion/MuestraSecciones";
import comprueboPermisos from "../tools/comprueboPermisos";
import PasesDeSalida from "../NCadetes/PasesDeSalida";
import GuardiaComponent from "../GuardiaPrevencion/GuardiaComponent";
import DevuelveListados from "./DevuelveListados";
import MuestraEstadosDivisiones from "./MuestraEstadosDivisiones";

const DivisionEstudio = () => {
    const [visible, setvisible] = useState(false);
    const [verSecciones, setverSecciones] = useState(false);
    const [porIndividuo, setPorIndividuo] = useState(false);
    const [secciones, setSecciones] = useState([]); // Secciones obtenidas de la API
    const [compañias, setCompanias] = useState([]); // Compañías agrupadas
    const [verPasesSalidaArea, setverPasesSalidaArea] = useState(false);
    const [verZonaGuardia,setverZonaGuardia]=useState(false)
    const [veoAulas,setVeoAulas]=useState(false)
    const [veoBuscar,setVeoBuscar]=useState(false)
    const navitate = useNavigate()
    const Usuario = ObtieneDatosCookies()
    const volver = () => {
        navitate('/usuarioLogueado')
    }





    const obtenerSecciones = async () => {
        try {

            const response = await axios.post(
                "https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones"
            );
            const seccionesData = response.data || [];
            setSecciones(seccionesData);

            // Agrupar las secciones por compañía
            const companiasAgrupadas = seccionesData.reduce((acc, seccion) => {
                const { nombre } = seccion.Compania;
                if (!acc[nombre]) {
                    acc[nombre] = [];
                }
                acc[nombre].push(seccion);
                return acc;
            }, {});

            // Obtener los nombres de las compañías para el primer select
            setCompanias(Object.keys(companiasAgrupadas));
        } catch (error) {
            console.error("Error al obtener las secciones", error);
        }
    };

    useEffect(() => {

        obtenerSecciones();
        return () => {

        };
    }, []);



    const miroDatosCadete = (info) => {
        window.open('/CadeteEdit?dni=' + info.cadeteDni, '_blank');
      };

    return (<>
        <div style={{ display: "flex", justifyContent: "center", flexDirection:"column", padding:"10px",alignItems:"center" }}>
            <h3 style={{ textAlign: "center", background:"#456", width:"100%", color:"white"}}>Division Estudio</h3>
            <button className="btn btn-warning" style={{width:"80px", height:"40px"}} onClick={() => volver()}>Volver</button>
        </div>
       
          
   
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", textAlign:"center", width:"100%"}}>
            <div >
                <h5 className="btn btn-success"onClick={()=>setVeoAulas(!veoAulas)}>Ver aulas</h5>
               {
                veoAulas? <div style={{width:"100"}}>
                <MuestraEstadosDivisiones />
                </div>:""
               }
               
           
            </div>
         <div style={{marginTop:"10px"}}>
         <h4 className="btn btn-primary" onClick={()=>setVeoBuscar(!veoBuscar)}>Buscar Cadetes</h4>
           {veoBuscar? <>          
            <div style={{width:"400px"}} >
                <h4>Presentes</h4>
            <CadetesBuscadorPresente devuelvo={(a)=>miroDatosCadete(a)}/>
            </div>
            <div style={{width:"400px", maxHeight:"500px",overflow:"auto"}}>
                <h4>En General</h4>
            <CadetesBuscador devuelvo={(a)=>miroDatosCadete(a)}/>
            </div></>:""} 

            </div>
            {verSecciones ? <div style={{ border: " black 2px solid", margin: "10px", width: "98%", height: "auto", textAlign: "center", overflow: "auto", display: "flex", flexDirection: "column", alignItems: "center" }} >


//                 <MuestraSecciones sede={Usuario.sedeID} devuelve={(va) => console.log(va)} />

                {porIndividuo ? <div>

//                     <CadetesBuscadorPresente devuelvo={(a) => console.log(a)} />
                </div> : ""}

            </div> : ""
            }

        </div>
        {verPasesSalidaArea ? <div style={{ border: " black 2px solid", margin: "10px", justifyContent: "center", width: "auto", height: "auto", textAlign: "center" }}>
            <PasesDeSalida />
        </div> : ""
        }

        {verZonaGuardia ? <>        <div style={{ border: " black 2px solid", margin: "10px", justifyContent: "center", width: "100%", height: "auto", textAlign: "center" }}>
            {Usuario.sedeID == 1 ? <>
                <GuardiaComponent sede={"Rosario"} />
                <GuardiaComponent sede={"Recreo"} /></> : Usuario.sedeID == 2 ? <>
                    <GuardiaComponent sede={"Rosario"} /> 
                    
                    
                    
                    </> : <>
                    
                    
                    
                    
                    
                    
                    <GuardiaComponent sede={"Recreo"} />
                    
                    
                    
                    
                    
                    
                    </>}


        </div></> : <></>
        }

        {visible ? <> <div style={{ border: " black 2px solid", margin: "10px", justifyContent: "center", width: "200px", height: "300px", textAlign: "center" }}>
            Proxima Guardia
        </div>
            <div style={{ border: " black 2px solid", margin: "10px", justifyContent: "center", width: "200px", height: "300px", textAlign: "center" }}>
                Avisos de Ausencias del dia de mañana
            </div></> : ""}


       
        <div style={{ display: "flex", margin: "10px", width: "100%", justifyContent: "center" }}>
            <FooterCorp />
        </div>
    </>)
}
export default DivisionEstudio